import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import useApi from "../customHooks/useAPI";

const Reports = ({ patientID }) => {
    const [reports, setReports] = useState([]);
    const {callApi, loading} = useApi();
    const {callApi: getUrl} = useApi();

    const fetchReports = async () => {
        try {
            const response = await callApi({
                url: `${process.env.REACT_APP_BACKEND_ENDPOINT}/patient/myReports`,
                method: "GET",
                headers: { "Patient-Id": patientID },
            });

            console.log(response.data);

            setReports(response.data || []);
        } catch (error) {
            console.error("Error fetching reports:", error);
        }
    };
    
    const openReportHandler = async (url) => {
        const endPoint = `${process.env.REACT_APP_BACKEND_ENDPOINT}/common/s3UrlGenerator?key=reports/${url}`
        const response = await getUrl({
            url:endPoint, 
            method: "GET",
            headers: { "Patient-Id": patientID },
        })
        
        window.open(response.data, "_blank");
    }

    useEffect(() => {
        fetchReports();
    }, []);

    if (loading) {
        return <div className="text-gray-500 text-sm">Loading reports...</div>;
    }

    if (!reports.length) {
        return (
            <div className="h-fit">
                <h3 className="text-lg font-semibold mb-4">Reports</h3>
                <div className="text-gray-500 text-sm">No report available</div>
            </div>
        );
    }

    return (
        <div className="reportContainer max-h-[50vh] overflow-scroll">
            <h3 className="text-lg font-semibold mb-4">Reports</h3>
            <div className="flex flex-col gap-3">
                {reports.map((report) => (
                        <div
                            key={report.id}
                            className="p-3 border rounded-lg bg-white shadow hover:shadow-md transition-all cursor-pointer"
                        onClick={() => openReportHandler(`${report.patientId}/${report.reportDate}/${report.reportName}.pdf`)}
                        >
                            <h4 className="text-sm font-bold text-gray-800">{report.reportName}</h4>
                            <p className="text-xs text-gray-500">
                                <strong>Report Date:</strong>{" "}
                                {new Date(report.reportDate).toLocaleDateString()}
                            </p>
                            <p className="text-xs text-gray-500">
                                <strong>Updated:</strong>{" "}
                                {new Date(report.updatedAt).toLocaleDateString()}
                            </p>
                        </div>
                ))}
            </div>
        </div>
    );
};

export default Reports;
